import { BASEURI, headers } from "../../utils/helper";
import { createAsyncThunk } from "@reduxjs/toolkit";
import thunkHandler from "../thunkHandler";

// ——————————————— Availability ops ———————————————

// -------- Create|Update slots --------
export const createAvailability = createAsyncThunk(
  "create",
  async (data, thunkAPI) => {

    return thunkHandler(
      {
        data,
        method: "POST",
        headers: headers(),
        url: `${BASEURI}/specialist/slots/create`,
      },
      thunkAPI,
    );
  }
);

// -------- Update pricing --------
export const updatePricing = createAsyncThunk(
  "update-pricing",
  async (data, thunkAPI) => {

    return thunkHandler(
      {
        data,
        method: "PUT",
        headers: headers(),
        url: `${BASEURI}/specialist/slots/pricing`,
      },
      thunkAPI,
    );
  }
);

// -------- Get all slots --------
export const getAllAvailability = createAsyncThunk(
  "get-all",
  async (day, thunkAPI) => {

    return thunkHandler(
      {
        method: "GET",
        headers: headers(),
        url: `${BASEURI}/specialist/slots/${day}`,
      },
      thunkAPI,
      { successToast: false }
    );
  }
);

// -------- Delete single slot --------
export const deleteSingleAvailability = createAsyncThunk(
  "delete",
  async (id, thunkAPI) => {

    return thunkHandler(
      {
        method: "DELETE",
        headers: headers(),
        url: `${BASEURI}/specialist/slots/${id}`,
      },
      thunkAPI,
    );
  }
);

// -------- Enable slot --------
export const enableSinleSlot = createAsyncThunk(
  "update",
  async (id, thunkAPI) => {

    return thunkHandler(
      {
        method: "PUT",
        headers: headers(),
        url: `${BASEURI}/specialist/slots/enable/${id}`,
      },
      thunkAPI,
    );
  }
);

// -------- Disable slot --------
export const disableSinleSlot = createAsyncThunk(
  "update",
  async (id, thunkAPI) => {

    return thunkHandler(
      {
        method: "PUT",
        headers: headers(),
        url: `${BASEURI}/specialist/slots/disable/${id}`,
      },
      thunkAPI,
    );
  }
);

// ——————————————— Exception ops ———————————————

// -------- Create exception --------
export const createException = createAsyncThunk(
  "create",
  async (data, thunkAPI) => {

    return thunkHandler(
      {
        data,
        method: "POST",
        headers: headers(),
        url: `${BASEURI}/specialist/exception/create`,
      },
      thunkAPI,
    );
  }
);

// -------- Get all exceptions --------
export const getAllExceptions = createAsyncThunk(
  "get-all",
  async (_, thunkAPI) => {

    return thunkHandler(
      {
        method: "GET",
        headers: headers(),
        url: `${BASEURI}/specialist/exception/all`,
      },
      thunkAPI,
      { successToast: false }
    );
  }
);

// -------- Delete exceptions --------
export const deleteExceptions = createAsyncThunk(
  "delete",
  async (id, thunkAPI) => {

    return thunkHandler(
      {
        method: "DELETE",
        headers: headers(),
        url: `${BASEURI}/specialist/exception/${id}`,
      },
      thunkAPI,
    );
  }
);

// -------- Update exception --------
export const updateException = createAsyncThunk(
  "create",
  async (data, thunkAPI) => {

    return thunkHandler(
      {
        method: "PUT",
        data: data?.data,
        headers: headers(),
        url: `${BASEURI}/specialist/exception/${data?.id}`,
      },
      thunkAPI,
      { successToast: false }
    );
  }
);